import React from 'react';
import classNames from 'classnames/bind';
import styles from './RenameCamera.module.css'
import { HeaderModal, InputTextBox } from '../../../../components';
import { useTranslation } from 'react-i18next';

const cx = classNames.bind(styles)
const RenameCamera = ({ handleClose, nameCamera, setNameCamera, reNameCamera }) => {
    const { t } = useTranslation();
    return (
        <div className={cx("container")}>
            <div className={cx("content")}>
                <HeaderModal onClose={handleClose} title={t("stream.reNameCam")} />
                <div className={cx("form")}>
                    <InputTextBox value={nameCamera.name} onChange={(data) => setNameCamera({ ...nameCamera, name: data })} title={t("stream.nameCamera")} placeholder={t("stream.type")} />
                </div>
                <div className={cx("actions")}>
                    <button onClick={handleClose} className={cx("btn", "cancel")}>{t("stream.cancel")}</button>
                    <button onClick={reNameCamera} className={cx("btn", "ok")}>{t("stream.save")}</button>
                </div>
            </div>
        </div>
    );
};

export default RenameCamera;